(function (angular) {
	'use strict';

	angular.module('updatedDocumentsModule', [
		'coreModule'
	]);
})(window.angular);